import React, { useState } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import Select from "react-select";
import { useCreateTicketType } from '../../../hooks/TICKET/useCreateTicketType';
import { useColors } from '../../../hooks/COLORS/useColors';
import { customSelectStyles } from '../../../utils/reactSelectStyles';

const NewTypeTicket = ({ showNewTypeTicket, setShowNewTypeTicket }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ nom: '', label: '', couleur: null, defaut: false });

    const { mutateAsync: createType } = useCreateTicketType();
    const { data: colorsData, isLoading: isLoadingColors } = useColors();

    const colorOptions = colorsData?.data?.map(color => ({ value: color.id.toString(), label: color.name, hex: color.hex })) ?? [];

    const formatColorOption = ({ label, hex }) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ width: '14px', height: '14px', borderRadius: '50%', backgroundColor: hex || '#e9ecef', border: '1px solid #ced4da', flexShrink: 0 }} />
            <span>{label}</span>
        </div>
    );

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        if (!formData.nom) { alert("Le nom est obligatoire"); return; }
        setIsSubmitting(true);
        try {
            await createType({ nom: formData.nom, label: formData.label || undefined, couleur: formData.couleur ? parseInt(formData.couleur.value) : undefined, defaut: formData.defaut });
            setFormData({ nom: '', label: '', couleur: null, defaut: false });
            setShowNewTypeTicket(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={showNewTypeTicket} onHide={() => setShowNewTypeTicket(false)} size='lg'>
            <Form onSubmit={handleSubmitForm}>
                <Modal.Header closeButton>
                    <Modal.Title><h5 className='text-muted modal-title'>Ajouter un type de ticket</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Form.Group className="mb-3" as={Col} controlId="idNom">
                            <Form.Label className='text-muted'>Nom (obligatoire)</Form.Label>
                            <Form.Control type="text" placeholder="Nom du type" value={formData.nom} onChange={(e) => setFormData({ ...formData, nom: e.target.value })} required />
                        </Form.Group>
                        <Form.Group className="mb-3" as={Col} controlId="idLabel">
                            <Form.Label className='text-muted'>Label (optionnel)</Form.Label>
                            <Form.Control type="text" placeholder="Label du type" value={formData.label} onChange={(e) => setFormData({ ...formData, label: e.target.value })} />
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group className='mb-3' as={Col} controlId="idCouleur">
                            <Form.Label className='text-muted'>Choisissez une couleur (optionnel)</Form.Label>
                            <Select options={colorOptions} value={formData.couleur} formatOptionLabel={formatColorOption} onChange={(option) => setFormData({ ...formData, couleur: option })} isLoading={isLoadingColors} menuPortalTarget={document.body} styles={{ ...customSelectStyles, menuPortal: base => ({ ...base, zIndex: 9999 }) }} placeholder="Sélectionnez une couleur" isClearable />
                        </Form.Group>
                        <Form.Group className='mb-3' as={Col} controlId="previsuCouleur">
                            <Form.Label className='text-muted'>Prévisualisation</Form.Label>
                            <div style={{ height: '38px', border: '1px solid #ced4da', borderRadius: '0.375rem', backgroundColor: formData.couleur?.hex || '#e9ecef' }} />
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group className="mb-3" controlId="idDefaut">
                            <Form.Check type="checkbox" label="Type par défaut" checked={formData.defaut} onChange={(e) => setFormData({ ...formData, defaut: e.target.checked })} />
                        </Form.Group>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" disabled={isSubmitting} onClick={() => setShowNewTypeTicket(false)}>Annuler</Button>
                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Chargement...' : 'Créer'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default NewTypeTicket;